import { formatInteger, formatPercent } from '@brimo/shared';
import type { ControllingFigures } from './api';
import styles from './figures.module.css';

/**
 * „Vom Lead zur Beurkundung" (Controlling 04, A3): seven rows — label · bar (value ÷ leads, navy) with the thin
 * accent marker of the previous period (previous value ÷ current leads) · value with the conversion to the row
 * before (none on „Leads"). Widths and percentages arrive from the API.
 */
export function Funnel({ rows }: { rows: ControllingFigures['funnel'] }) {
  return (
    <section className={`${styles.card} ${styles.funnelCard}`} aria-labelledby="figures-funnel-title">
      <h2 id="figures-funnel-title" className={styles.cardTitle}>
        Vom Lead zur Beurkundung
      </h2>
      <div className={styles.funnel} role="list">
        {rows.map((row) => {
          const conversion = row.conversionPct === null ? null : formatPercent(row.conversionPct, 0);
          return (
            <div key={row.key} className={styles.funnelRow} role="listitem" aria-label={row.label}>
              <span className={styles.funnelLabel}>{row.label}</span>
              <span
                className={styles.track}
                role="img"
                aria-label={`${formatPercent(row.barPct, 1)} der Leads, Vorperiode ${formatPercent(row.markerPct, 1)}`}
              >
                <span className={styles.fill} style={{ width: `${row.barPct}%` }} />
                <span
                  className={styles.marker}
                  style={{ left: `min(${row.markerPct}%, calc(100% - 2px))` }}
                />
              </span>
              <span className={styles.funnelValue}>
                {formatInteger(row.value)}
                {conversion ? <span className={styles.conversion}> {conversion}</span> : null}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
